var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHobbiesIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.084,
  cy: 20,
  fill: "#FFF09F",
  rx: 20.045,
  ry: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M29.23 13.86H26.44l-.505-1.68a1.77 1.77 0 0 0-1.695-1.26h-3.749a1.77 1.77 0 0 0-1.695 1.26l-.505 1.68H11.77A1.77 1.77 0 0 0 10 15.63v10.68c0 .977.793 1.77 1.77 1.77h17.46A1.77 1.77 0 0 0 31 26.31V15.63a1.77 1.77 0 0 0-1.77-1.77m-6.876 11.737a4.72 4.72 0 1 1 0-9.44 4.72 4.72 0 0 1 0 9.44"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M22.354 17.927a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 0 0 0-5.9m2.055 2.835c-.278.277-.97.036-1.547-.54-.576-.577-.818-1.27-.54-1.547.278-.278.97-.036 1.547.54.576.576.818 1.269.54 1.547M15.797 12.93a.78.78 0 0 0-.781-.781h-1.683a.78.78 0 0 0-.781.781v.395h3.245z"
})));
export default SvgHobbiesIco;